"use strict";
/*
 * Created on 29/01/2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LocalisationRow_1 = require("../model/LocalisationRow");

var LocalisationRowConverter_1 = require("./LocalisationRowConverter");
/**
 * TODO
 *
 * @author JMr
 */


var LocalisationRowConverterImpl =
/*#__PURE__*/
function (_LocalisationRowConve) {
  _inherits(LocalisationRowConverterImpl, _LocalisationRowConve);

  function LocalisationRowConverterImpl() {
    _classCallCheck(this, LocalisationRowConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocalisationRowConverterImpl).apply(this, arguments));
  }

  _createClass(LocalisationRowConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        locale: source.locale,
        key: source.key,
        value: source.value
      });
      return document;
    }
  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new LocalisationRow_1.LocalisationRow(conversions.documentToClassId(source), source.locale, source.key, source.value);
    }
  }]);

  return LocalisationRowConverterImpl;
}(LocalisationRowConverter_1.LocalisationRowConverter);

exports.LocalisationRowConverterImpl = LocalisationRowConverterImpl;